<template>
  <div class="t-28 fw-7 onyx">Home Page</div>
</template>